import { Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Home";
import Paan from "./menu/Paan";
import Chaat from "./menu/Chaat";
import Pizza from "./menu/Pizza";
import Chai from "./menu/Chai";
import Beverage from "./menu/Beverage";
import Kulfi from "./menu/Kulfi";

function App() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/paan" element={<Paan />} />
				<Route path="/chaat" element={<Chaat />} />
				<Route path="/pizza" element={<Pizza />} />
				<Route path="/chai" element={<Chai />} />
				<Route path="/beverage" element={<Beverage />} />
				<Route path="/kulfi" element={<Kulfi />} />
			</Routes>
		</>
	);
}

export default App;
